<clr-modal [(clrModalOpen)]="open">
  <h3 class="modal-title">
    {{ options?.title }}
  </h3>

  <div class="modal-body">
    <p style="margin-top: -5px; margin-left: 15px; white-space: pre-line">{{ options?.message }}</p>
  </div>

  <div class="modal-footer">
    <button #okBtn class="btn btn-primary" (click)="ok()">
      {{ options?.okText }}
    </button>
  </div>
</clr-modal>
